(function(){
  const ROOTEL = document.querySelector('.ttp-root');
  if(!ROOTEL) return;
  const CAT       = ROOTEL.dataset.category;
  const LABEL     = ROOTEL.dataset.label;
  const GRID_HEAD = ROOTEL.dataset.gridHead || LABEL;
  const MINE_HEAD = 'Currently on your profile';
  const BROWSE_HEAD = 'All ' + LABEL;
  const FIELD = {
    client:   ROOTEL.dataset.fClient   || '',
    category: ROOTEL.dataset.fCategory || '',
    keep:     ROOTEL.dataset.fKeep     || '',
    add:      ROOTEL.dataset.fAdd      || '',
    remove:   ROOTEL.dataset.fRemove   || '',
    note:     ROOTEL.dataset.fNote     || '',
    company:  ROOTEL.dataset.fCompany  || ''
  };
  const WIRED = !!(FIELD.client && FIELD.keep);
  const P    = JSON.parse(ROOTEL.querySelector('.ttp-data').textContent)
                 .filter(p => p.id)
                 .map(p => Object.assign({}, p, {
                   needs: p.needs ? p.needs.split('|') : [],
                   fits:  p.fits  ? p.fits.split('|')  : []
                 }));

  /* Brand logos: optional, per brand. Bad JSON must not take the page down. */
  let LOGOS = {};
  try{
    const el = ROOTEL.querySelector('.ttp-brandlogos');
    if(el) LOGOS = JSON.parse(el.textContent) || {};
  }catch(e){ console.warn('TT picker: brand logo JSON is not valid, falling back to text.'); }

  /* Sizing values that get their own group at the bottom of the results.
     Everything with no fit- tag at all is the main grid and is never grouped. */
  const VARIANT = ['Women\u2019s','Tall','Youth'];
  /* ---- IDENTITY STATE. Release 3, C-narrow, 2026-09-15. --------------
     `slug` now holds the VERIFIED shop and nothing else. It is '' until
     /apps/manage/whoami says otherwise, so every existing `if(!slug) return`
     guard below became an authorization check without being touched. */
  const urlSlug = (new URLSearchParams(location.search).get('client') || '')
                    .trim().toLowerCase();
  const SLUG_OK = /^[a-z0-9][a-z0-9-]{0,63}$/;
  const WHOAMI_URL = '/apps/manage/whoami';
  const WHOAMI_TIMEOUT_MS = 6000;
  let idState  = 'pending';
  let shops    = [];
  let mismatch = false;
  let slug     = '';

  /* ---- MANAGE SHOP RETURN MARKER. Ruling 2026-09-16. -----------------
     NAVIGATION ONLY. `from` decides which href the Back button gets and
     NOTHING ELSE. It is never identity, never authorization, and it is read
     in exactly one place - setBackLink(). ?client= remains a PROPOSAL that
     /whoami validates; this is NOT a precedent for trusting the URL.

     Accepted value: the single literal 'manage'. Anything else is ignored,
     and the raw value is never written into the DOM or into an href.

     🔴 THE ACCOUNT PAGE UUID IS A LITERAL AND ITS STABILITY IS UNVERIFIED.
     Re-read it from the address bar after every app deploy. If it is ever
     blank the marker is ignored and the profile link is used: a wrong
     constant must degrade to the old behaviour, never to a dead button. */
  const MANAGE_SHOP_URL =
    'https://account.techniciantees.com/pages/01a071aa-c258-7b76-900f-29c2ac983234';
  const fromManage =
    (new URLSearchParams(location.search).get('from') || '')
      .trim().toLowerCase() === 'manage';
  const NONE = 'No Preference';

  /* Tag values are single CamelCase words: LongSleeve -> Long Sleeve.
     Applied to EVERY option family including Needs, so a new value like
     Need-EasyCare reads as "Easy Care" with no code change. */
  const pretty = s => String(s||'').replace(/([a-z])([A-Z])/g, '$1 $2');

  /* Decoration is derived from Menu- tags, so its values are internal words.
     No trade terms in front of a customer -- printed, not DTF. */
  const DECO_DISPLAY = {
    'Printable': 'Printed or embroidered',
    'EmbroideryOnly': 'Embroidery only'
  };

  /* Cut values that need a friendlier label than pretty() produces. */
  const CUT_DISPLAY = {
    'Trucker': 'Trucker / Mesh Back'
  };

  /* Sleeve and pocket are TWO INDEPENDENT GROUPS, not one. A shirt can be
     long sleeved and pocketed; the old single Style- row could not say that. */
  const SLEEVE_DISPLAY = {
    'ThreeQuarter': '3/4 Sleeve',
    'Short': 'Short Sleeve',
    'Long': 'Long Sleeve'
  };
  const POCKET_DISPLAY = {
    'Chest': 'Pocket',
    'None': 'No Pocket'
  };

  /* Closure- drives the Preferred Fit group. Adjustable covers snapback,
     hook-and-loop and buckle strap; Stretch is closed-back stretch fit. */
  const CLOSURE_DISPLAY = {
    'Stretch': 'Stretch Fit'
  };

  let onNeeds = new Set(), onFits = new Set();
  let fab = NONE, wt = NONE, cut = NONE, blen = NONE, sleeve = NONE,
      pocket = NONE, len = NONE, closure = NONE, deco = NONE,
      brand = 'All Brands', mineOnly = false;
  let original = new Set();
  let chosen   = new Set();
  let clientName = '', loadedPage = false;

  /* Display order for the Needs group. A value NOT listed here still renders --
     it just sorts to the end, which is a useful tell for a typo'd tag. */
  const NEED_ORDER = ['EasyCare','Value','Professional','Durability',
                      'Flexibility','Performance','Comfort','Premium','Safety'];
  const present = new Set(); P.forEach(p => p.needs.forEach(n => present.add(n)));
  const NEEDS = NEED_ORDER.filter(n => present.has(n))
                  .concat([...present].filter(n => !NEED_ORDER.includes(n)).sort());

  /* the default band in each family -- shown as a card badge only when the
     product is NOT the default, since a badge on two thirds of the grid is noise */
  const DEFAULT_CUT    = 'Regular';
  const DEFAULT_WT     = 'Midweight';
  const DEFAULT_CLO    = 'Adjustable';
  const DEFAULT_LEN    = 'Pants';
  const DEFAULT_SLEEVE = 'Short';
  const DEFAULT_POCKET = 'None';

  const BRANDS = [...new Set(P.map(p => p.brand).filter(Boolean))].sort();
  const BRAND_VISIBLE = 6;

  const DUPE = !!document.getElementById('tt-client-logo-wrap');
  const coEl   = document.getElementById('ttp-co');
  const logoEl = document.getElementById('ttp-logo');
  if(DUPE){
    if(logoEl) logoEl.remove();
    if(coEl)   coEl.remove();
  }

  /* ---- Company Name autofill ----------------------------------------
     Moved here from sections/main-page.liquid, which is disabled on picker
     pages. PFB restores its own values after render, so poll rather than
     set once. Gives up after ~10s. */
  let companyTimer = null;
  function syncCompany(){
    if(!FIELD.company || !clientName) return;
    if(companyTimer) clearInterval(companyTimer);
    let tries = 0;
    const put = () => {
      const el = document.querySelector('.globo-form-app [name="'+FIELD.company+'"]');
      if(el && el.value !== clientName){
        el.value = clientName;
        el.dispatchEvent(new Event('input',{bubbles:true}));
        el.dispatchEvent(new Event('change',{bubbles:true}));
      }
      if(++tries >= 40) clearInterval(companyTimer);
    };
    put();
    companyTimer = setInterval(put, 250);
  }

  /* ============================================================
     IDENTITY - /apps/manage/whoami

     ONE authority: the App Proxy endpoint, which Shopify signs and the
     Worker verifies. ?client= may PROPOSE a shop; only /whoami can
     authorize one. localStorage and sessionStorage are never read or
     written by this file.

     SIX STATES, AND NONE OF THEM MAY COLLAPSE INTO ANOTHER:
       pending  the answer has not arrived yet. Fail-closed and SILENT -
                no copy, no chooser, no client data. This is the state the
                page STARTS in, so the catalog renders without waiting.
       browse   signed out
       manage   signed in, exactly one shop resolved
       choose   signed in, two or more shops, none resolved yet
       none     signed in, authorized for zero shops
       unknown  non-200, network failure, timeout, or a malformed answer

     'unknown' IS NOT 'browse' AND IS NOT 'none'. "We could not find out" is
     a different fact from "you are not authorized for anything", and the
     Worker keeps the three distinguishable on purpose. Do not merge them.
     ============================================================ */

  async function resolveIdentity(){
    let data = null;
    try{
      const ctl = (typeof AbortController === 'function') ? new AbortController() : null;
      const timer = setTimeout(function(){ if(ctl) ctl.abort(); }, WHOAMI_TIMEOUT_MS);
      const r = await fetch(WHOAMI_URL, ctl ? { signal: ctl.signal } : undefined);
      clearTimeout(timer);
      if(r.status !== 200) throw 0;
      data = await r.json();
    }catch(e){
      idState = 'unknown';
      return;
    }

    /* Fail closed on anything that is not exactly the documented shape. */
    if(!data || data.ok !== true || typeof data.signed_in !== 'boolean' ||
       !Array.isArray(data.shops) ||
       !data.shops.every(x => typeof x === 'string' && SLUG_OK.test(x))){
      idState = 'unknown';
      return;
    }

    if(!data.signed_in){ idState = 'browse'; return; }

    shops = data.shops.slice();
    if(!shops.length){ idState = 'none'; return; }

    /* C3 - one shop auto-selects. */
    if(shops.length === 1){
      slug = shops[0];
      idState = 'manage';
      /* Ruling (ii), 2026-09-15: a mismatched deep link is NOT silently
         swallowed. Verified identity wins and the customer is told. */
      if(urlSlug && urlSlug !== slug) mismatch = true;
      return;
    }

    /* C2 - ?client= selects among VERIFIED shops, and is authority for
       nothing. A value that is not in the list is discarded, not obeyed. */
    if(urlSlug && shops.indexOf(urlSlug) !== -1){
      slug = urlSlug;
      idState = 'manage';
      return;
    }
    if(urlSlug) mismatch = true;
    idState = 'choose';
  }

  /* One label per state. 'Sign in to manage' appears ONLY in 'browse' - i.e.
     only once /whoami has actually told us the visitor is signed out. Before
     the answer arrives the button says what is true: we are still checking.
     Ruling 2026-09-15. */
  const BTN_LABEL = {
    pending: 'Checking access\u2026',
    browse:  'Sign in to manage',
    choose:  'Choose a profile',
    none:    'No profile linked',
    unknown: 'Access unavailable',
    manage:  'Update my profile'
  };

  const STATE_COPY = {
    browse:  'Sign in to manage your company profile.',
    none:    'You are signed in, but no company profile is linked to your ' +
             'account yet. Contact us and we will set it up.',
    unknown: 'We could not check your profile just now. You can still browse. ' +
             'Please refresh, or contact us if this keeps happening.'
  };

  /* The back link is owned here since Release 3. snippets/tt-picker-back.liquid
     is markup and CSS only and resolves nothing itself. */
  function setBackLink(){
    const el = document.getElementById('ttp-back');
    if(!el) return;
    if(idState === 'manage' && slug){
      /* Marker present AND the constant is non-empty -> Manage Shop.
         Anything else -> exactly what this line computed before. */
      el.setAttribute('href',
        (fromManage && MANAGE_SHOP_URL)
          ? MANAGE_SHOP_URL
          : '/collections/' + encodeURIComponent(slug));
      el.hidden = false;
    }else{
      el.hidden = true;
    }
  }

  /* ---- CHOOSE-state friendly titles. Ruling 2026-09-16. --------------
     DISPLAY ONLY, and deliberately NOT loadClient(). loadClient() writes
     clientName, #ttp-co, document.title and the logo; running it once per
     candidate would stamp one company's identity onto the page before the
     customer has chosen anything. This reads the profile collection title
     and NOTHING else - the logo value is not read.

     Authorization is unchanged. The only slugs ever fetched here come from
     the /whoami-verified `shops` array, and selection still runs through
     chooseShop(), which re-checks that same array. The displayed title is
     never authority for anything. */
  const CHOOSER_TITLE   = {};
  const CHOOSER_PENDING = {};

  async function chooserTitle(sh){
    /* Verified shops only. Defence in depth - mirrors chooseShop(). */
    if(shops.indexOf(sh) === -1) return;
    if(CHOOSER_TITLE[sh] || CHOOSER_PENDING[sh]) return;
    CHOOSER_PENDING[sh] = true;
    try{
      const r = await fetch('/collections/'+encodeURIComponent(sh)+'?section_id=client-data');
      if(!r.ok) throw 0;
      const doc = new DOMParser().parseFromString(await r.text(),'text/html');
      const d = doc.querySelector('#tt-client-data');
      if(!d) throw 0;
      const t = d.dataset.clientTitle || '';
      if(!t) throw 0;
      CHOOSER_TITLE[sh] = t;
      paintChooserLabel(sh);
    }catch(e){
      /* 404, timeout, malformed, no title: the slug stays on the button. */
    }
  }

  /* Upgrades one label in place. Guarded so a late answer can never revive a
     chooser the customer has already left, and never touches anything else. */
  function paintChooserLabel(sh){
    if(idState !== 'choose') return;
    const box = document.getElementById('ttp-chooser');
    if(!box || box.hidden) return;
    const b = box.querySelector('.ttp-chooser-btn[data-slug="'+sh+'"]');
    if(b && CHOOSER_TITLE[sh]) b.textContent = CHOOSER_TITLE[sh];
  }

  function renderChooser(){
    const box = document.getElementById('ttp-chooser');
    if(!box) return;
    box.innerHTML = '';
    if(idState !== 'choose'){ box.hidden = true; return; }
    const h = document.createElement('p');
    h.className = 'ttp-chooser-head';
    h.textContent = 'Which company profile are you working on?';
    box.appendChild(h);
    shops.forEach(function(sh){
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ttp-chooser-btn';
      b.dataset.slug = sh;
      b.textContent = CHOOSER_TITLE[sh] || sh;
      b.onclick = function(){ chooseShop(sh); };
      box.appendChild(b);
    });
    box.hidden = false;
    /* Fire and forget. The chooser is painted above, on slugs, before any of
       this runs - nothing here is awaited and nothing waits on it. */
    shops.forEach(function(sh){ chooserTitle(sh); });
  }

  async function chooseShop(sh){
    /* The verified list, and nothing else, can ever be selected. */
    if(shops.indexOf(sh) === -1) return;
    slug = sh;
    idState = 'manage';
    mismatch = false;
    /* Safe: the next page load re-verifies this against /whoami. The URL is
       a convenience and is never trusted. */
    try{
      const u = new URL(window.location.href);
      u.searchParams.set('client', sh);
      history.replaceState(null, '', u.toString());
    }catch(e){}
    applyIdentityUI();
    await Promise.all([loadClient(), loadCurrent()]);
    buildScope(); draw(); tray();
  }

  function applyIdentityUI(){
    const msg  = document.getElementById('ttp-idstate');
    const go   = document.getElementById('ttp-go');
    const noun = document.getElementById('ttp-tn-noun');
    const trayEl = document.getElementById('ttp-tray');

    let text = STATE_COPY[idState] || '';
    if(idState === 'manage' && mismatch){
      text = 'Showing the company profile your account is authorized for. ' +
             'The link you followed asked for a different one.';
    }
    if(msg){
      msg.textContent = text;
      msg.hidden = !text;
    }
    if(noun) noun.textContent = (idState === 'manage') ? 'on your profile' : 'selected';
    if(go){
      go.textContent = BTN_LABEL[idState] || BTN_LABEL.pending;
      /* Always re-disabled here. Only tray(), through ready(), enables it. */
      go.disabled = true;
    }
    if(trayEl && idState !== 'manage') trayEl.classList.remove('on');
    renderChooser();
    setBackLink();
  }

  async function loadClient(){
    if(!slug) return;
    if(coEl) coEl.textContent = slug;
    try{
      const r = await fetch('/collections/'+encodeURIComponent(slug)+'?section_id=client-data');
      if(!r.ok) throw 0;
      const doc = new DOMParser().parseFromString(await r.text(),'text/html');
      const d = doc.querySelector('#tt-client-data');
      if(!d) throw 0;
      clientName = d.dataset.clientTitle || '';
      const logo = d.dataset.clientLogo || '';
      if(clientName){
        if(coEl) coEl.textContent = clientName;
        document.title = LABEL+' \u2014 '+clientName;
      }
      if(logo && logoEl){
        const img = document.getElementById('ttp-logoimg');
        img.src = logo; img.alt = (clientName||slug)+' logo';
        img.onload = () => logoEl.classList.add('on');
      }
    }catch(e){}
  }

  async function loadCurrent(){
    if(!slug) return;
    try{
      const r = await fetch('/collections/'+encodeURIComponent(slug)+'-'+CAT+
                            '?section_id=tt-client-products');
      if(!r.ok) throw 0;
      const doc = new DOMParser().parseFromString(await r.text(),'text/html');
      const d = doc.querySelector('#tt-client-products');
      if(!d) throw 0;
      (d.dataset.skus||'').split(',').map(s=>s.trim().toUpperCase())
        .filter(Boolean).forEach(s => { original.add(s); chosen.add(s); });
      loadedPage = true;
    }catch(e){}
  }

  /* ---- one option row ------------------------------------------------
     Indicator plus label. The indicator's SHAPE comes from the container:
     .ttp-opts.single gives round (single-select, picking replaces),
     plain .ttp-opts gives square (multi-select, picks add up). The controls
     were made to match the engine -- the engine was NOT changed to make the
     controls uniform. */
  function optButton(value, text){
    const b = document.createElement('button');
    b.className = 'ttp-opt';
    b.type = 'button';
    b.dataset.v = value;
    b.setAttribute('aria-pressed','false');
    const ind = document.createElement('span');
    ind.className = 'ttp-ind';
    const lab = document.createElement('span');
    lab.className = 'ttp-optlab';
    lab.textContent = text;
    b.appendChild(ind); b.appendChild(lab);
    return b;
  }

  /* ---- multi-select groups -------------------------------------------
     Needs and Sizing. OR logic within the group, no "No Preference" option --
     none selected means everything.

     THE labelId ARGUMENT IS THE WHOLE RAIL GROUP. Each <section> carries the
     id that used to belong to the row's label, so when a category has fewer
     than two values the entire group hides itself with no extra code.

     SIZING HAS NO "Unisex" OPTION BY DESIGN. It used to represent the absence
     of a fit- tag, which presented 23 of 34 tees as unisex when no
     manufacturer said so. Positive claims only. */
  function buildMulti(chipsId, labelId, values, order, set, displayMap){
    const el  = document.getElementById(chipsId);
    const lab = document.getElementById(labelId);
    if(!el) return null;
    const real = [...new Set(values.filter(Boolean))];
    if(real.length < 2){
      el.style.display = 'none';
      if(lab) lab.style.display = 'none';
      return null;
    }
    const list = order.filter(v => real.includes(v))
                   .concat(real.filter(v => !order.includes(v)).sort());
    list.forEach(k => {
      const b = optButton(k, (displayMap && displayMap[k]) ? displayMap[k] : pretty(k));
      b.onclick = () => {
        set.has(k) ? set.delete(k) : set.add(k);
        b.setAttribute('aria-pressed', String(set.has(k)));
        draw();
      };
      el.appendChild(b);
    });
    return el;
  }
  function repaintMulti(el, set){
    if(!el) return;
    [...el.children].forEach(c =>
      c.setAttribute('aria-pressed', String(set.has(c.dataset.v))));
  }

  const needsEl = buildMulti('ttp-needs', 'ttp-needs-q', NEEDS, NEED_ORDER, onNeeds);

  const ALL_FITS = P.reduce((a,p) => a.concat(p.fits), []);
  const sizeEl = buildMulti('ttp-sizes', 'ttp-size-q', ALL_FITS,
    ['Men\u2019s','Women\u2019s','Tall','Youth'], onFits);

  /* ---- single-select groups ------------------------------------------
     Fabric, Weight, Cut, Body length, Sleeve, Pocket, Length, Fit and
     Decoration are the same control with different data. A group is absent
     from the DOM when its label is blank in theme settings, and hides itself
     here when the master holds fewer than two real values. Returns the
     options container, or null when not in play. */
  function buildRow(chipsId, labelId, values, order, onPick, displayMap){
    const el  = document.getElementById(chipsId);
    const lab = document.getElementById(labelId);
    if(!el) return null;
    const real = [...new Set(values.filter(Boolean))];
    if(real.length < 2){
      el.style.display = 'none';
      if(lab) lab.style.display = 'none';
      return null;
    }
    const list = [NONE].concat(
      order.filter(v => real.includes(v))
        .concat(real.filter(v => !order.includes(v)).sort()));
    list.forEach(k => {
      const b = optButton(k, k === NONE ? k
                    : (displayMap && displayMap[k]) ? displayMap[k]
                    : pretty(k));
      if(k === NONE) b.setAttribute('aria-pressed','true');
      b.onclick = () => {
        onPick(k);
        [...el.children].forEach(c =>
          c.setAttribute('aria-pressed', String(c.dataset.v === k)));
        draw();
      };
      el.appendChild(b);
    });
    return el;
  }
  function repaintRow(el, value){
    if(!el) return;
    [...el.children].forEach(c =>
      c.setAttribute('aria-pressed', String(c.dataset.v === value)));
  }

  const fabEl = buildRow('ttp-fabs', 'ttp-fab-q',
    P.map(p => p.fabric), ['Cotton','Blend','Polyester'], v => { fab = v; });
  const wtEl = buildRow('ttp-wts', 'ttp-wt-q',
    P.map(p => p.wt), ['Lightweight','Midweight','Heavyweight'], v => { wt = v; });
  const cutEl = buildRow('ttp-cuts', 'ttp-cut-q',
    P.map(p => p.cut),
    ['Regular','Crewneck','Hoodie','QuarterZip','FullZip','Softshell',
     'Fleece','WorkDuck','Parka','Trucker','SolidBack','Work','Cargo',
     'Jogger','Dress'],
    v => { cut = v; }, CUT_DISPLAY);

  /* BODY LENGTH -- Regular vs Tall, DERIVED in the Liquid from fit-tall.
     Regular is NOT a tag and must not become one. Only renders where
     bodylen_label is set in theme settings (Sweats today); everywhere else
     the section is absent from the DOM, buildRow returns null, and blen
     stays NONE so the match() clause below is a pass-through.
     This is a LENGTH claim, not a gender claim -- see the long block at the
     top of sections/tt-category-picker.liquid before changing it. */
  const blenEl = buildRow('ttp-blens', 'ttp-blen-q',
    P.map(p => p.blen), ['Regular','Tall'], v => { blen = v; });

  const sleeveEl = buildRow('ttp-sleeves', 'ttp-sleeve-q',
    P.map(p => p.sleeve), ['Short','Long','ThreeQuarter'],
    v => { sleeve = v; }, SLEEVE_DISPLAY);
  const pocketEl = buildRow('ttp-pockets', 'ttp-pocket-q',
    P.map(p => p.pocket), ['Chest','None'],
    v => { pocket = v; }, POCKET_DISPLAY);
  const lenEl = buildRow('ttp-lens', 'ttp-len-q',
    P.map(p => p.len), ['Pants','Shorts'], v => { len = v; });
  const fitEl = buildRow('ttp-fits', 'ttp-fit-q',
    P.map(p => p.closure), ['Adjustable','Stretch'],
    v => { closure = v; }, CLOSURE_DISPLAY);
  const decoEl = buildRow('ttp-decos', 'ttp-deco-q',
    P.map(p => p.deco), ['Printable','EmbroideryOnly'],
    v => { deco = v; }, DECO_DISPLAY);

  const brandWrap = document.getElementById('ttp-brands');
  const brandEl   = document.getElementById('ttp-brand-chips');

  function brandChip(k, isAll){
    const b = optButton(k, k);
    b.classList.add('ttp-brand');
    b.dataset.b = k;
    const url = !isAll && LOGOS[k];
    if(url){
      const lab = b.querySelector('.ttp-optlab');
      const img = document.createElement('img');
      img.src = url; img.alt = k; img.loading = 'lazy'; img.className = 'ttp-optlogo';
      img.onerror = () => { img.remove(); lab.textContent = k; };
      lab.textContent = '';
      lab.appendChild(img);
    }
    return b;
  }

  function repaintBrands(){
    if(!brandEl) return;
    [...brandEl.children].forEach(c => {
      if(c.dataset.b) c.setAttribute('aria-pressed', String(c.dataset.b === brand));
    });
  }

  /* Entirely data driven. BRANDS comes from the Brand- tags on whatever is in
     the master collection. Tag a new product correctly and its brand appears
     on its own. The group stays hidden until a second brand exists, because
     one option plus "All Brands" is not a choice. */
  function buildBrands(){
    if(BRANDS.length < 2) return;
    brandWrap.classList.add('show');
    const all = ['All Brands'].concat(BRANDS);
    all.forEach((k,i) => {
      const b = brandChip(k, i===0);
      if(i > BRAND_VISIBLE) b.classList.add('hidden');
      b.setAttribute('aria-pressed',String(k===brand));
      b.onclick=()=>{ brand=k; repaintBrands(); draw(); };
      brandEl.appendChild(b);
    });
    if(all.length > BRAND_VISIBLE+1){
      const more=document.createElement('button');
      more.className='ttp-more'; more.type='button';
      let open=false;
      more.textContent='Show all brands';
      more.onclick=()=>{ open=!open;
        [...brandEl.children].forEach((c,i)=>{
          if(c.dataset.b && i > BRAND_VISIBLE) c.classList.toggle('hidden', !open);
        });
        more.textContent = open ? 'Show fewer brands' : 'Show all brands'; };
      brandEl.appendChild(more);
    }
  }
  buildBrands();

  /* ============================================================
     THE FILTER RAIL

     Every applicable group is OPEN on desktop. There is no master control, no
     accordion and no toggle. Technician Tees has a handful of dimensions with
     a handful of values each -- progressive disclosure solves a volume problem
     this catalogue does not have, and hiding the controls hid the picker's
     best feature. Do not reintroduce a desktop collapse.

     ADDING A DIMENSION LATER: add its <section> to the Liquid and one line
     here. Nothing else changes -- not the layout, not the grid, not the other
     ten pickers. Price, Decoration Type, Work Environment: all one more line.

     BUT NOTE: the RAIL entry is DISPLAY only. A group that actually filters
     also needs a clause in match(), a clause in anyFilterActive() and a line
     in resetFilters(). Miss either of the last two and Clear all silently
     stops clearing that group.

       val   what the collapsed state line reads ON MOBILE ONLY
       el    the options container, or NULL when the group is not in play
     ============================================================ */

  /* "Comfort, Durability +1" -- first two, then a count. Only ever seen on a
     phone, where groups collapse. */
  function multiVal(set){
    const v = [...set].map(x => pretty(x));
    if(!v.length) return NONE;
    if(v.length <= 2) return v.join(', ');
    return v.slice(0,2).join(', ') + ' +' + (v.length - 2);
  }
  function oneVal(v, map){
    if(v === NONE) return NONE;
    return (map && map[v]) ? map[v] : pretty(v);
  }

  const RAIL = [
    { valId:'ttp-val-needs',  el:needsEl,  val:() => multiVal(onNeeds) },
    { valId:'ttp-val-fab',    el:fabEl,    val:() => oneVal(fab) },
    { valId:'ttp-val-wt',     el:wtEl,     val:() => oneVal(wt) },
    { valId:'ttp-val-cut',    el:cutEl,    val:() => oneVal(cut, CUT_DISPLAY) },
    { valId:'ttp-val-blen',   el:blenEl,   val:() => oneVal(blen) },
    { valId:'ttp-val-sleeve', el:sleeveEl, val:() => oneVal(sleeve, SLEEVE_DISPLAY) },
    { valId:'ttp-val-pocket', el:pocketEl, val:() => oneVal(pocket, POCKET_DISPLAY) },
    { valId:'ttp-val-len',    el:lenEl,    val:() => oneVal(len) },
    { valId:'ttp-val-size',   el:sizeEl,   val:() => multiVal(onFits) },
    { valId:'ttp-val-fit',    el:fitEl,    val:() => oneVal(closure, CLOSURE_DISPLAY) },
    { valId:'ttp-val-deco',   el:decoEl,   val:() => oneVal(deco, DECO_DISPLAY) },
    { valId:'ttp-val-brand',  el:brandEl,  val:() => brand,
      live:() => !!(brandWrap && brandWrap.classList.contains('show')) }
  ];

  /* ONE definition of "is anything filtered". The grid count, the Clear all
     button state and the mobile state lines all read it, so they can never
     disagree about whether the customer has narrowed anything. */
  function anyFilterActive(){
    return !!(onNeeds.size || onFits.size ||
      fab !== NONE || wt !== NONE || cut !== NONE || blen !== NONE ||
      sleeve !== NONE || pocket !== NONE || len !== NONE ||
      closure !== NONE || deco !== NONE ||
      brand !== 'All Brands');
  }

  const layoutEl = document.getElementById('ttp-layout');
  const railEl   = document.getElementById('ttp-rail');
  let   clearBtn = null;

  function paintRail(){
    RAIL.forEach(r => {
      const el = document.getElementById(r.valId);
      if(el) el.textContent = r.val();
    });
    if(clearBtn) clearBtn.disabled = !anyFilterActive();
  }

  (function setupRail(){
    if(!railEl) return;

    /* A group is live if its row produced options, or -- for brand -- if
       buildBrands revealed it. Nothing else survives. */
    const anyLive = RAIL.some(r => r.live ? r.live() : !!r.el);

    if(!anyLive){
      railEl.remove();
      if(layoutEl) layoutEl.classList.add('norail');
      return;
    }

    /* CLEAR ALL is built here rather than in the Liquid so the section markup
       did not have to change for one button. It restores every group to its
       default -- No Preference on the single-selects, nothing ticked on the
       multi-selects, All Brands -- by calling the same clearAll() the
       no-results message uses. Scope is deliberately NOT reset: All vs My
       Current is not a filter. */
    const head = railEl.querySelector('.ttp-rail-head');
    if(head){
      clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.className = 'ttp-clear';
      clearBtn.id = 'ttp-clear';
      clearBtn.textContent = 'Clear all';
      clearBtn.disabled = true;
      clearBtn.onclick = () => clearAll();
      head.appendChild(clearBtn);
    }

    const groups = [...railEl.querySelectorAll('.ttp-grp')].filter(g =>
      g.style.display !== 'none' &&
      (g.id !== 'ttp-brands' || g.classList.contains('show')));

    function shut(g){
      const body = g.querySelector('.ttp-grp-body');
      const btn  = g.querySelector('.ttp-grp-btn');
      if(body) body.setAttribute('hidden','');
      if(btn)  btn.setAttribute('aria-expanded','false');
      g.classList.remove('open');
    }
    function open(g){
      const body = g.querySelector('.ttp-grp-body');
      const btn  = g.querySelector('.ttp-grp-btn');
      if(body) body.removeAttribute('hidden');
      if(btn)  btn.setAttribute('aria-expanded','true');
      g.classList.add('open');
    }

    /* MOBILE ONLY. On a phone an open list of every value is taller than the
       screen, so the group headers become real accordion buttons and all but
       the first collapse. On desktop every group is open and the header is
       inert. This is the ONLY behavioural difference between the two, and it
       is one matchMedia line -- there is no second filtering system. */
    const MQ = window.matchMedia('(max-width:860px)');

    function applyMode(){
      if(MQ.matches){
        groups.forEach((g,i) => i === 0 ? open(g) : shut(g));
      }else{
        groups.forEach(open);
      }
    }

    groups.forEach(g => {
      const btn = g.querySelector('.ttp-grp-btn');
      if(!btn) return;
      btn.onclick = () => {
        if(!MQ.matches) return;          /* desktop headers do nothing */
        const wasOpen = g.classList.contains('open');
        groups.forEach(shut);
        if(!wasOpen) open(g);
      };
    });

    applyMode();
    if(MQ.addEventListener) MQ.addEventListener('change', applyMode);
    else if(MQ.addListener) MQ.addListener(applyMode);
  })();

  /* ---- scope: All <label> vs My Current <label> ----------------------
     Scope is not a filter -- it changes WHICH SET you are looking at.
     So switching scope clears the selections, and paintRail() inside draw()
     puts the Clear all button and every mobile state line back to default. */
  const segEl   = document.getElementById('ttp-seg');
  const segAll  = document.getElementById('ttp-seg-all');
  const segMine = document.getElementById('ttp-seg-mine');

  function paintScope(){
    segAll.setAttribute('aria-pressed', String(!mineOnly));
    segMine.setAttribute('aria-pressed', String(mineOnly));
  }
  function buildScope(){
    if(!original.size) return;
    segEl.classList.add('show');
    segAll.textContent  = 'All ' + LABEL;
    segMine.textContent = 'My Current ' + LABEL;
    segAll.onclick  = () => setScope(false);
    segMine.onclick = () => setScope(true);
    paintScope();
  }
  function setScope(next){
    if(mineOnly === next) return;
    mineOnly = next;
    resetFilters();
    paintScope();
    draw();
  }

  const askBtn  = document.getElementById('ttp-ask-btn');
  const askBox  = document.getElementById('ttp-ask-box');
  const askText = document.getElementById('ttp-ask-text');
  const note = () => (askText && askText.value || '').trim();
  if(askBtn){
    askBtn.onclick=()=>{
      const open = askBox.classList.toggle('on');
      askBtn.setAttribute('aria-expanded', String(open));
      if(open) askText.focus();
    };
  }
  if(askText){
    askText.addEventListener('input', tray);
    /* A category-appropriate placeholder can be set in theme settings.
       The auto-generated fallback is apparel-shaped and reads wrong on
       Promos and Pants, which is why the setting exists. */
    askText.placeholder = askText.dataset.ph ||
      ('For example: a lighter ' +
       LABEL.toLowerCase().replace(/s$/,'') + ' for summer, a hi-vis option, ' +
       'or a brand you have used before.');
  }

  /* OR within a multi-select group, AND between every group. Picking Long
     Sleeve and No Pocket narrows to shirts that are BOTH -- not either. */
  const match = p =>
    (!onNeeds.size || p.needs.some(n=>onNeeds.has(n))) &&
    (!onFits.size  || p.fits.some(f=>onFits.has(f))) &&
    (fab===NONE  || p.fabric===fab) &&
    (wt===NONE   || p.wt===wt) &&
    (cut===NONE  || p.cut===cut) &&
    (blen===NONE || p.blen===blen) &&
    (sleeve===NONE || p.sleeve===sleeve) &&
    (pocket===NONE || p.pocket===pocket) &&
    (len===NONE  || p.len===len) &&
    (closure===NONE || p.closure===closure) &&
    (deco===NONE || p.deco===deco) &&
    (brand==='All Brands' || p.brand===brand) &&
    (!mineOnly || original.has(p.id));

  const esc = s => String(s==null?'':s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');

  const isVariant = p => p.fits.some(f => VARIANT.includes(f));

  function state(id){
    const was = original.has(id), now = chosen.has(id);
    if(now && !was) return 'add';
    if(!now && was) return 'remove';
    if(now && was)  return 'keep';
    return 'none';
  }

  function draw(){
    /* First, so the rail is right even on the no-results early return below. */
    paintRail();

    const res = document.getElementById('ttp-results');
    const hits = P.filter(match);
    let base = hits.filter(p=>!isVariant(p));
    let cuts = hits.filter(p=> isVariant(p));

    /* A heading over a single card is noise, and when the sizing group is
       narrowed to a variant there is no main grid to separate it from.
       Below two variant items they simply join the main grid -- the same
       "below two values" rule the groups use. */
    if(cuts.length < 2 || !base.length){ base = base.concat(cuts); cuts = []; }

    const filtering = anyFilterActive();

    document.getElementById('ttp-scope-title').textContent =
      mineOnly ? MINE_HEAD : (idState === 'manage' ? GRID_HEAD : BROWSE_HEAD);

    const total = mineOnly ? original.size : P.length;
    document.getElementById('ttp-count').textContent =
      filtering ? hits.length + ' of ' + total
                : total + ' ' + LABEL;

    res.innerHTML='';
    if(!hits.length){
      res.innerHTML='<div class="ttp-empty">Nothing matches that combination.<br>'+
        'Try widening one of the filters, or clear them to see everything.'+
        '<br><button type="button" id="ttp-clr">Clear filters</button></div>';
      document.getElementById('ttp-clr').onclick=clearAll;
      return;
    }
    res.appendChild(grid(base));
    if(cuts.length){
      const kinds = [...new Set(cuts.reduce((a,p)=>
        a.concat(p.fits.filter(f=>VARIANT.includes(f))), []))].sort();
      res.appendChild(head(kinds.join(' \u00b7 ') + ' sizes'));
      res.appendChild(grid(cuts));
    }
  }

  /* clears the selections only. Scope is deliberately left alone. */
  function resetFilters(){
    onNeeds.clear(); onFits.clear();
    fab=NONE; wt=NONE; cut=NONE; blen=NONE; sleeve=NONE; pocket=NONE; len=NONE;
    closure=NONE; deco=NONE; brand='All Brands';
    repaintMulti(needsEl, onNeeds);
    repaintMulti(sizeEl, onFits);
    repaintRow(fabEl, fab);
    repaintRow(wtEl, wt);
    repaintRow(cutEl, cut);
    repaintRow(blenEl, blen);
    repaintRow(sleeveEl, sleeve);
    repaintRow(pocketEl, pocket);
    repaintRow(lenEl, len);
    repaintRow(fitEl, closure);
    repaintRow(decoEl, deco);
    repaintBrands();
  }
  function clearAll(){ resetFilters(); draw(); }

  function head(t){ const h=document.createElement('div'); h.className='ttp-gh'; h.textContent=t; return h; }

  function grid(list){
    const g=document.createElement('div'); g.className='ttp-grid';
    list.forEach(p=>{
      const st=state(p.id);
      const c=document.createElement('div');
      c.className='ttp-card'+(st==='keep'||st==='add'?' on':'')+(st==='remove'?' off':'');
      c.tabIndex=0; c.setAttribute('role','button');
      c.setAttribute('aria-label',p.name+', style '+p.id+
        (st==='keep'?', on your profile':st==='add'?', being added':st==='remove'?', being removed':''));
      c.innerHTML=
        (st==='keep'?'<span class="ttp-flag now">On your profile</span>':'')+
        (st==='add' ?'<span class="ttp-flag">Adding</span>':'')+
        (st==='remove'?'<span class="ttp-flag" style="background:#b4261e">Removing</span>':'')+
        (st==='keep'||st==='add'?'<span class="ttp-tick">&#10003;</span>':'')+
        (st==='remove'?'<span class="ttp-tick">&times;</span>':'')+
        '<div class="ttp-shot"><img loading="lazy" src="'+esc(p.img)+'" alt="'+esc(p.name)+'"></div>'+
        '<div class="ttp-meta"><span class="ttp-sid">'+esc(p.id)+'</span>'+
        '<span class="ttp-name">'+esc(p.name)+'</span>'+
        '<span class="ttp-sub"><span>'+esc(p.brand)+'</span>'+
        '<span class="ttp-price">'+esc(p.price)+'</span></span>'+
        '<span class="ttp-marks">'+
          (p.cut && p.cut!==DEFAULT_CUT?'<span class="ttp-mark">'+esc(CUT_DISPLAY[p.cut]||pretty(p.cut))+'</span>':'')+
          (p.sleeve && p.sleeve!==DEFAULT_SLEEVE?'<span class="ttp-mark">'+esc(SLEEVE_DISPLAY[p.sleeve]||pretty(p.sleeve))+'</span>':'')+
          (p.pocket && p.pocket!==DEFAULT_POCKET?'<span class="ttp-mark">'+esc(POCKET_DISPLAY[p.pocket]||pretty(p.pocket))+'</span>':'')+
          (p.len && p.len!==DEFAULT_LEN?'<span class="ttp-mark">'+esc(pretty(p.len))+'</span>':'')+
          (p.wt && p.wt!==DEFAULT_WT?'<span class="ttp-mark">'+esc(pretty(p.wt))+'</span>':'')+
          (p.closure && p.closure!==DEFAULT_CLO?'<span class="ttp-mark">'+esc(CLOSURE_DISPLAY[p.closure]||pretty(p.closure))+'</span>':'')+
          (p.deco==='EmbroideryOnly'?'<span class="ttp-mark">Embroidery only</span>':'')+
          (p.look?'<span class="ttp-mark">'+esc(p.look)+'</span>':'')+
          (p.fabric?'<span class="ttp-mark">'+esc(p.fabric)+'</span>':'')+
          p.fits.map(f=>'<span class="ttp-mark">'+esc(f)+'</span>').join('')+
        '</span></div>'+
        '<div class="ttp-hint">Tap for details</div>';
      c.onclick=()=>open_(p);
      c.onkeydown=e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); open_(p); } };
      g.appendChild(c);
    });
    return g;
  }

  function open_(p){
    const st=state(p.id);
    const m=document.getElementById('ttp-modal');
    const btn = (st==='keep')  ? ['off','Take off my profile']
              : (st==='add')   ? ['on','&#10003; Being added']
              : (st==='remove')? ['','Keep it on my profile']
              :                  ['','Add to my profile'];
    m.innerHTML=
      '<button type="button" class="ttp-mclose" id="ttp-mclose" aria-label="Close">&times;</button>'+
      '<div class="ttp-mshot"><img src="'+esc(p.img)+'" alt="'+esc(p.name)+'"></div>'+
      '<div class="ttp-mbody"><span class="ttp-mbrand">'+esc(p.brand)+'</span>'+
      '<h3 class="ttp-mname">'+esc(p.name)+'</h3>'+
      '<span class="ttp-msid">Style '+esc(p.id)+'</span>'+
      '<div class="ttp-tags">'+p.needs.map(n=>'<span class="ttp-tag">'+esc(pretty(n))+'</span>').join('')+'</div>'+
      (p.note?'<p class="ttp-note">'+esc(p.note)+'</p>':'')+
      '<dl class="ttp-specs">'+
        (p.cut?'<dt>Style</dt><dd>'+esc(CUT_DISPLAY[p.cut]||pretty(p.cut))+'</dd>':'')+
        (p.sleeve?'<dt>Sleeve</dt><dd>'+esc(SLEEVE_DISPLAY[p.sleeve]||pretty(p.sleeve))+'</dd>':'')+
        (p.pocket?'<dt>Pocket</dt><dd>'+esc(POCKET_DISPLAY[p.pocket]||pretty(p.pocket))+'</dd>':'')+
        (p.len?'<dt>Length</dt><dd>'+esc(pretty(p.len))+'</dd>':'')+
        (p.wt?'<dt>Weight</dt><dd>'+esc(pretty(p.wt))+'</dd>':'')+
        (p.closure?'<dt>Fit</dt><dd>'+esc(CLOSURE_DISPLAY[p.closure]||pretty(p.closure))+'</dd>':'')+
        (p.fabric?'<dt>Fabric</dt><dd>'+esc(p.fabric)+'</dd>':'')+
        (p.deco?'<dt>Decoration</dt><dd>'+esc(DECO_DISPLAY[p.deco]||pretty(p.deco))+'</dd>':'')+
        (p.look?'<dt>Look</dt><dd>'+esc(p.look)+'</dd>':'')+
        (p.fits.length?'<dt>Sizing</dt><dd>'+esc(p.fits.join(', '))+'</dd>':'')+
        '<dt>Price</dt><dd>'+esc(p.price)+'</dd></dl>'+
      '<button type="button" class="ttp-madd '+btn[0]+'" id="ttp-madd">'+btn[1]+'</button></div>';
    document.getElementById('ttp-scrim').classList.add('on');
    document.getElementById('ttp-mclose').onclick=close_;
    document.getElementById('ttp-madd').onclick=()=>{
      chosen.has(p.id) ? chosen.delete(p.id) : chosen.add(p.id);
      close_(); draw(); tray();
    };
  }
  function close_(){ document.getElementById('ttp-scrim').classList.remove('on'); }
  document.getElementById('ttp-scrim').onclick=e=>{ if(e.target.id==='ttp-scrim') close_(); };
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') close_(); });

  const adds    = () => [...chosen].filter(id=>!original.has(id));
  const removes = () => [...original].filter(id=>!chosen.has(id));

  function tray(){
    const a=adds(), r=removes();
    document.getElementById('ttp-tn').textContent = chosen.size;
    const bits=[];
    if(a.length) bits.push('+ '+a.join(', '));
    if(r.length) bits.push('\u2212 '+r.join(', '));
    if(note())   bits.push('plus a question for us');
    document.getElementById('ttp-tdelta').textContent = bits.join('   \u00b7   ');

    const conf=document.getElementById('ttp-confirm');
    const box =document.getElementById('ttp-confirm-box');
    if(r.length){
      conf.classList.add('on');
      const names=r.map(id=>{ const p=P.find(x=>x.id===id); return p?p.id+' '+p.name:id; });
      document.getElementById('ttp-confirm-list').textContent =
        names.join(' \u00b7 ')+'. '+
        (r.length===1?'This comes off':'These come off')+' your profile. '+
        'Nothing is deleted \u2014 you can add '+(r.length===1?'it':'them')+' back anytime.';
    }else{
      conf.classList.remove('on'); box.checked=false;
    }
    document.getElementById('ttp-go').disabled = !ready();
    document.getElementById('ttp-tray').classList.toggle('on',
      idState === 'manage' && (a.length>0 || r.length>0 || note().length>0));
    fillForm();
    gateSubmit();
  }
  function ready(){
    /* RELEASE 3: no verified shop, no submission. This is the gate that did
       not exist - a signed-out visitor who selected anything used to satisfy
       ready() and reach the Globo form with an empty client field. */
    if(idState !== 'manage' || !slug) return false;
    const r=removes();
    if(r.length && !document.getElementById('ttp-confirm-box').checked) return false;
    if(!adds().length && !r.length && !note()) return false;
    return true;
  }
  document.getElementById('ttp-confirm-box').onchange=()=>{
    document.getElementById('ttp-go').disabled=!ready();
    gateSubmit();
  };

  const NL = String.fromCharCode(10);
  const lines = ids => [...ids].map(id=>{
    const p=P.find(x=>x.id===id);
    return p ? p.id+' \u2014 '+p.brand+' '+p.name : id;
  }).join(NL);

  /* ---- the PFB form -------------------------------------------------
     The form does its own submitting and its own validation. We only keep
     the payload fields filled and stop the client reaching Submit while a
     removal is unconfirmed. Never call form.submit(). */

  function fieldEl(name){
    return name ? document.querySelector('.globo-form-app [name="'+name+'"]') : null;
  }

  function fieldRow(el){
    let n = el.parentElement, hops = 0;
    while(n && hops < 5){
      if(n.tagName === 'FORM' || n.classList.contains('globo-form-app')) return el;
      const cls = typeof n.className === 'string' ? n.className : '';
      if(/control|element|field|item|row|col/i.test(cls)) return n;
      n = n.parentElement; hops++;
    }
    return el;
  }

  function hidePayloadFields(){
    ['client','category','keep','add','remove','note'].forEach(k => {
      const el = fieldEl(FIELD[k]);
      if(el) fieldRow(el).style.display = 'none';
    });
  }

  function setField(name, value){
    const el = fieldEl(name);
    if(!el) return false;
    el.value = value;
    el.dispatchEvent(new Event('input',{bubbles:true}));
    el.dispatchEvent(new Event('change',{bubbles:true}));
    return true;
  }

  function fillForm(){
    if(!WIRED) return;
    /* Never write a blank, 'Unknown' or 'Blank' client. No verified shop
       means no payload at all. */
    if(idState !== 'manage' || !slug) return;
    const noChange = !adds().length && !removes().length;
    const n = note();
    setField(FIELD.client,   slug || '');
    setField(FIELD.category, CAT);
    setField(FIELD.keep,     lines(chosen));
    setField(FIELD.add,      adds().length ? lines(adds()) : '');
    setField(FIELD.remove,   removes().length ? lines(removes()) : '');
    setField(FIELD.note,     noChange && n ? 'No changes to the profile. Asking about: '+n : n);
  }

  function gateSubmit(){
    const btn = document.querySelector('.globo-form-app [type="submit"], .globo-form-app button.globo-form-btn-submit');
    if(!btn) return;
    const ok = ready();
    btn.disabled = !ok;
    btn.style.opacity = ok ? '' : '.45';
    btn.style.cursor  = ok ? '' : 'not-allowed';
  }

  function send(){
    if(!ready()) return;

    if(WIRED){
      const missing = ['client','category','keep','add','remove','note']
        .filter(k => FIELD[k] && !fieldEl(FIELD[k]));
      if(missing.length){
        console.warn('TT picker: payload fields not on the page:', missing.join(', '));
        alert('Something is not wired up correctly on our end. '+
              'Please email us and we will sort it out.');
        return;
      }
      fillForm();
      syncCompany();
      const app = document.querySelector('.globo-form-app');
      if(app){
        app.scrollIntoView({behavior:'smooth', block:'start'});
        const first = fieldEl('name-1') || app.querySelector('input:not([type=hidden])');
        if(first) setTimeout(()=>first.focus({preventScroll:true}), 450);
        return;
      }
      console.warn('TT picker: no Globo form found on the page.');
    }

    const noChange = !adds().length && !removes().length;
    const n = note();
    alert(['PREVIEW \u2014 not yet wired to a form.','',
      'Client: '+(clientName||slug||'(no verified shop)'),
      'Slug: '+(slug||'-'),
      'Category: '+CAT,'',
      'KEEPING ('+chosen.size+'):', lines(chosen)]
      .concat(adds().length?['','ADDING:',lines(adds())]:[])
      .concat(removes().length?['','REMOVING:',lines(removes())]:[])
      .concat(n?['','ASKING ABOUT:', noChange ? 'No changes to the profile. Asking about: '+n : n]:[])
      .join(NL));
  }
  document.getElementById('ttp-go').onclick=send;

  (async function init(){
    /* ---- CATALOG FIRST, IDENTITY IN PARALLEL. Approved 2026-09-15. ----

       THE GRID IS PUBLIC AND MUST NEVER WAIT ON THE IDENTITY SERVICE. It is
       built from the Liquid JSON blob already in the page, so it needs no
       network at all. A slow or dead /whoami degrades browsing to exactly
       nothing.

       The page STARTS fail-closed, in 'pending':
         - no client name, no logo, no current SKUs   (loadClient and
           loadCurrent both guard on `slug`, which is still '')
         - #ttp-go disabled and labelled for the signed-out case
         - no chooser, no state copy, no management state anywhere

       Identity then resolves in the background and UPGRADES the page. It can
       only ever move it from less access to more, never the reverse, so a
       late answer cannot retract anything the customer was already using. */
    applyIdentityUI();
    buildScope(); draw(); tray();

    if(WIRED){
      let tries = 0;
      const t = setInterval(() => {
        tries++;
        if(fieldEl(FIELD.client)){
          hidePayloadFields(); fillForm(); gateSubmit(); syncCompany();
          clearInterval(t);
        }
        if(tries > 40) clearInterval(t);
      }, 250);
    }

    /* Deliberately NOT awaited. resolveIdentity() swallows its own failures
       and sets 'unknown'; the catch is belt-and-braces so that a fault here
       can never take the catalog down with it. */
    resolveIdentity().then(async function(){
      applyIdentityUI();
      await Promise.all([loadClient(), loadCurrent()]);
      buildScope(); draw(); tray();
    }).catch(function(){
      idState = 'unknown';
      applyIdentityUI();
      draw(); tray();
    });
  })();
})();